module.exports = __webpack_public_path__ + "static/media/loading.f07b1af5.png";